"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultButton = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_components_1 = require("@cimpress/react-components");
const withTooltip = (tooltip, content) => {
    if (!tooltip) {
        return content;
    }
    return react_1.default.createElement(react_components_1.Tooltip, { contents: tooltip }, content);
};
const clickHandler = (userHandler, key) => {
    return () => {
        userHandler();
    };
};
exports.DefaultButton = (props) => {
    const baseButton = (react_1.default.createElement("button", { autoFocus: !!props.autoFocus, className: classnames_1.default('rct-default-button', 'btn', { 'btn-sm': props.size === 'sm' }, { 'btn-lg': props.size === 'lg' }, `btn-${props.type}`, { disabled: props.disabled }), onClick: props.disabled ? undefined : clickHandler(props.onClick, props.gaKey) },
        props.icon && react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(props.icon, null),
            "\u00A0\u00A0"),
        props.title || props.children));
    if (props.disabled && props.disabledTooltip) {
        return withTooltip(props.disabledTooltip, baseButton);
    }
    if (props.tooltip) {
        return withTooltip(props.tooltip, baseButton);
    }
    return baseButton;
};
//# sourceMappingURL=DefaultButton.js.map